import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SmallCards from '../components/Cards/SmallCards';
import ContentCard from '../components/Cards/ContentCard';
import { Link } from 'react-router-dom';
import Accordions from '../components/Accordions/Accordions';
import { useTranslation } from '../hook/Translation';



export default function FemaleIntimateWellnessTwo() {
    const { t } = useTranslation();

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '15 to 20 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: 'Minimal Warmth'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: 'None'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '1 to 3'
        }
    ]

    const accodirons = [
        {
            title: 'What is it?',
            content: 'Microneedling that delivers radiofrequency into the dermis for tightening and scar revision.'
        },
        {
            title: 'How it works',
            content: 'Micro injuries plus RF heat trigger a strong wound healing response that builds new collagen and elastin.'
        },
        {
            title: 'Benefits',
            content: 'Firmer skin, smoother acne scars, refined pores, improved laxity and texture.'
        },
        {
            title: 'Areas',
            content: 'Face, jawline, neck, and select body areas such as shoulders or abdomen.'
        },
        {
            title: 'Pairs with other treatments',
            content: 'PRP or Emfusion right after to feed micro channels. Alternate with a fractional laser for surface plus depth.'
        },
        {
            title: 'Downtime details',
            content: 'Pinkness and pinpoint marks fade within days. Avoid heat and sun immediately after.'
        },
        {
            title: 'When to expect results',
            content: 'Cumulative lift and smoothing from 4 to 12 weeks.'
        },
    ];

    return (
        <Box>
            <Box>
                <HalfSizeBanner height={{ md: '460px', xs: 'auto' }}>
                    <Box sx={{ height: '100%', backgroundImage: 'linear-gradient(90deg, rgb(30, 53, 61) 50%, rgba(30, 53, 61, 0) 100%)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }} position={'relative'}>
                        <Grid container marginX={'auto'} spacing={12} paddingY={{ md: 'unset', xs: '30px' }} height={1} width={{ md: 1, xs: '90%' }}>
                            <Grid size={{ md: 6, xs: 12 }} height={1} position={'relative'} zIndex={2}>
                                <Grid container gap={{ md: '40px', xs: '20px' }} flexDirection={'column'} justifyContent={'center'} height={1} alignItems={{ md: 'end', xs: 'start' }}>
                                    <Grid size={'auto'}>
                                        <Typography sx={{ width: { md: '550px', xs: '100%' } }} className='wColor' variant='h1' fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'} fontFamily={'DanmarkURW'}>Female Intimate Wellness</Typography>
                                    </Grid>
                                    {/* <Grid width={{ md: '550px', xs: '100%' }}>
                                        <Typography sx={{ width: { md: '550px', xs: '100%' } }} mb={'16px'} className='wColor' variant='h1' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'500'}>Our Intimate Wellness therapies are designed to help women restore confidence, comfort, and function in intimate areas. These treatments focus on tissue support, pelvic strength, and overall quality of life.</Typography>
                                        <Button LinkComponent={Link} to={'/'} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'text.secondary', backgroundColor: 'primary.main', width: 'max-content' }}>
                                            Book Now
                                        </Button>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }} height={1} position={{ md: 'relative', xs: 'absolute' }} width={1} top={{ md: 'unset', xs: 0 }} left={{ md: 'unset', xs: 0 }} sx={{ opacity: { md: 1, xs: 0.6 } }}>
                                <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 1.png`} height={1} width={1} className='fitCover' />
                            </Grid>
                        </Grid>
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box marginTop={{ md: '90px', xs: '50px' }}>
                <Box className='generalContainer' marginX={'auto'}>
                    <Grid container spacing={8} position={'relative'} height={{ md: 400, xs: 'auto' }} padding={{ md: 'unset', xs: '20px' }}>
                        <Grid size={{ md: 6, xs: 12 }} position={{ md: 'relative', xs: 'absolute' }} top={0} left={0} width={1} height={1} zIndex={{ md: 'unset', xs: 1 }} sx={{ opacity: { md: 1, xs: 0.7 } }}>
                            <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 8_.png`} className='fitCover' width={1} height={1} />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }} zIndex={2}>
                            <Grid container height={1} justifyContent={'center'} alignItems={'start'}>
                                <Grid size={12} height={'max-content'}>
                                    <Grid container>
                                        <Grid size={12}>
                                            <Typography textAlign={'center'} variant="h3" color="text.secondary" fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'600'}>Female Intimate Wellness</Typography>
                                        </Grid>
                                        <Grid size={12} mt={{ md: '50px', xs: '20px' }}>
                                            <Typography textAlign={'center'} variant="h3" color="text.secondary" fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'}>Technology</Typography>
                                        </Grid>
                                        <Grid size={12} mt={{ md: '28px', xs: '20px' }}>
                                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '1rem', xs: '0.875rem' }}>Clarity II’s 755 nm wavelength is highly absorbed by melanin. It has proven effectiveness in treating age spots, lentigines, seborrheic keratoses, and small pigmented lesions. Lesions crust, lift, and clear within 1–3 weeks.</Typography>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid size={12} height={'max-content'} mt={{ md: '28px', xs: '20px' }}>
                                        <Grid container height={1} justifyContent={'center'}>
                                            <Grid size={{ md: 'auto', xs: 12 }}>
                                                <Button LinkComponent={Link} to={'/'} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                                    BOOK NOW
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Box>
                    <Box marginTop={{ md: '205px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                        <SmallCards data={data2} />
                    </Box>
                </Box>

                <Grid container className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{ md: '123px', xs: '50px' }}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                            The energy gently heats the vaginal wall to stimulate new collagen and improve tissue thickness and support. Many women report increased comfort, better sensation, and less mild stress leakage with coughing or exercise.
                        </Typography>
                        <Typography textAlign={'center'} mt={{ md: '40px', xs: '20px' }} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                            The treatment takes about fifteen to thirty minutes. No incisions and no injections. Most patients feel only warmth and do not need anesthesia.
                        </Typography>
                    </Grid>
                </Grid>


                <Box marginTop={{ md: '100px', xs: '50px' }}>
                    <Box className='generalContainer' marginX={'auto'}>
                        <ContentCard
                            data={{
                                descriptionStyle: { whiteSpace: 'pre-line' },
                                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 9.png`,
                                type: 'Pairing',
                                title: 'Emsella Chair Sessions',
                                description: `Emsella uses focused energy to make the pelvic floor muscles contract strongly while you sit comfortably and fully clothed. In one session, it creates thousands of contractions that go far beyond what regular Kegel exercises can do. 
                                
                                Internal laser or RF tightening works on the vaginal tissue, and Emsella works on the muscles that support it. Together they can improve tightness, control, comfort, and intimate confidence.`,
                                direction: { md: 'row-reverse', xs: 'row' },
                                book: "/skin/fractional-co2-resurfacing"
                            }}
                            heigth={{ md: '440px', xs: 'auto' }}
                        // pair={false}
                        />
                    </Box>
                </Box>


            </Box>

            <Grid container spacing={4} className="generalContainer" sx={{ marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }} mb={{md: '131px', xs: '50px'}}>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

        </Box >
    )
}